import { Stack, CircularProgress } from "@material-ui/core";

export function CalendarTasksLoading(): JSX.Element {
  return (
    <Stack sx={{ height: 384 }} justifyContent="center">
      <Stack sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
        <CircularProgress />
      </Stack>
    </Stack>
  );
}
